module.exports = __webpack_public_path__ + "64f924deb0fc15be3a8f740277ce6fe1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/backgrounds/leaves.png
// module id = 3175
// module chunks = 0